export const DEFAULT_PAGE_SIZE = 12
export const DEFAULT_PAGE = 1
export const DEFAULT_PAGINATION_SIZE_OPTIONS = [12, 24, 60, 120]
